import { render, staticRenderFns } from "./_FormFolder.vue?vue&type=template&id=b16b5a1e"
import script from "./_FormFolder.vue?vue&type=script&lang=js"
export * from "./_FormFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports